import React from "react";
import Modal from "react-bootstrap/Modal";
import { CloseIcon } from "asset/icons";
import { useNavigate } from "react-router-dom";

const SuccessShipmentModal = ({ show, setShow, shipmentId }) => {
    const navigate = useNavigate();
    const goTo = (shipmentId) => {
        sessionStorage.setItem("showShipmentRating", "true");
        navigate(`/flex/home/manage-shipment?shipmentId=${shipmentId}`);
    };
    return (
        <Modal show={show} contentClassName="!rounded-xl w-full max-w-[453px] mx-auto" centered>
            <div className="flex items-start justify-between p-3 pb-4">
                <div className="flex items-center gap-x-2">
                    {/* <img src={SuccessImage} alt="Success Icon" className="size-10" /> */}
                    <svg
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect width="60" height="60" rx="32" fill="#DCFDDB" />
                        <path
                            d="M38.7767 29.3348L38.7768 29.3348L38.7835 29.3279C39.3806 28.7102 39.3903 27.7269 38.7767 27.1133C38.1669 26.5035 37.1651 26.5035 36.5553 27.1133L30.106 33.5626L27.4434 30.9C26.8336 30.2902 25.8318 30.2902 25.222 30.9C24.6121 31.5098 24.6121 32.5116 25.222 33.1215L28.9953 36.8948C29.2879 37.1874 29.6861 37.3555 30.106 37.3555C30.526 37.3555 30.9241 37.1874 31.2167 36.8948L38.7767 29.3348ZM19.2374 31.9974C19.2374 24.9663 24.9683 19.2355 31.9993 19.2355C39.0304 19.2355 44.7613 24.9663 44.7613 31.9974C44.7613 39.0285 39.0304 44.7593 31.9993 44.7593C24.9683 44.7593 19.2374 39.0285 19.2374 31.9974Z"
                            fill="#11A811"
                            stroke="#11A811"
                            strokeWidth="1.14286"
                        />
                    </svg>

                    <div className="flex flex-col text-left">
                        <h5>Shipment booked succesfully</h5>

                        <p className="mb-2 text-sm font-normal text-main-grey">
                            You can manage this shipment from{" "}
                            <span
                                onClick={() => goTo(shipmentId)}
                                className="text-[#3B82F6] cursor-pointer"
                            >
                                here
                            </span>
                            .
                        </p>
                    </div>
                </div>
                <div className="flex items-start justify-center">
                    <CloseIcon
                        onClick={() => {
                            setShow(false)
                            navigate(`/flex/home/shipments`);
                        }}
                        className="!size-6 cursor-pointer text-[#667085] fill-[#667085] stroke-[#667085]"
                    />
                </div>
            </div>
            <Modal.Body className="flex flex-col items-center justify-start p-4 space-y-1 border-t">
                <button
                    className={`ml-auto w-auto flex px-3 py-2 text-base rounded-lg items-center justify-center border-none outline-none text-white !bg-secondary`}
                    type="button"
                    onClick={() => {
                        sessionStorage.setItem("showShipmentRating", "true");
                        navigate(`/flex/home/shipments`);
                    }}
                >
                    Go to shipments
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default SuccessShipmentModal;
